import { useState } from 'react';
import '../css/LineBrowserGuard.css';

function LineBrowserGuard() {
  const agent = navigator.userAgent || '';
  const isAndroid = /Android/i.test(agent);
  const isIOS = /iPhone|iPad|iPod/i.test(agent);
  const isLineBrowser = /Line\//i.test(agent) || (/; wv\)/i.test(agent) && /LIFF/i.test(agent));
  const [copied, setCopied] = useState(false);
  if ((!isAndroid && !isIOS) || !isLineBrowser) return null;

  const currentUrl = window.location.href;
  const url = new URL(currentUrl);
  const intentUrl = `intent://${url.host}${url.pathname}${url.search}${url.hash}#Intent;scheme=${url.protocol.replace(':', '')};package=com.android.chrome;S.browser_fallback_url=${encodeURIComponent(currentUrl)};end`;

  const copyUrl = async () => {
    try { await navigator.clipboard.writeText(currentUrl); setCopied(true); }
    catch { window.prompt('คัดลอกลิงก์นี้แล้วนำไปเปิดใน Safari', currentUrl); }
  };

  return <div className="line-browser-guard" role="alertdialog" aria-modal="true">
    <div><span>🌐</span><h1>{isIOS ? 'กรุณาเปิดด้วย Safari' : 'กรุณาเปิดด้วย Google Chrome'}</h1><p>ระบบไม่รองรับเบราว์เซอร์ภายใน LINE เนื่องจากกล้อง การแจ้งเตือน และการติดตั้ง Shortcut อาจทำงานไม่สมบูรณ์</p>{isAndroid ? <a href={intentUrl}>เปิดด้วย Google Chrome</a> : <button type="button" onClick={copyUrl}>{copied ? '✓ คัดลอกลิงก์แล้ว' : 'คัดลอกลิงก์ไปเปิดใน Safari'}</button>}<small>{isIOS ? 'จากนั้นเปิด Safari วางลิงก์ แล้วกดปุ่ม Share → Add to Home Screen' : 'หากปุ่มไม่ทำงาน ให้กดเมนู ⋮ ใน LINE แล้วเลือก “เปิดในเบราว์เซอร์อื่น”'}</small></div>
  </div>;
}

export default LineBrowserGuard;
